import { RegisteredComponent } from "@builder.io/sdk-react";

export const trustBadgeBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Trust Badge",
  inputs: [
    {
      name: "vendor",
      type: "enum",
      required: true,
      defaultValue: "g2",
      helperText:
        "The review platform this badge represents. The G2 renders only on functional cookies accepted.",
      enum: [
        { label: "G2", value: "g2" },
        { label: "Capterra", value: "capterra" },
        { label: "GetApp", value: "getapp" },
        { label: "Software Advice", value: "softwareadvice" },
      ],
      localized: false,
    },
    {
      name: "reviewUrl",
      type: "text",
      friendlyName: "Review page URL",
      required: true,
      helperText: "Where the badge links to (the vendor's review page).",
      localized: false,
    },
    {
      name: "badgeUrl",
      type: "text",
      friendlyName: "Badge image URL",
      required: true,
      helperText:
        "The vendor's badge image URL. For Capterra / GetApp / Software Advice it is re-served through our caching proxy automatically; for G2 the live widget image is used as-is.",
      localized: false,
    },
    {
      name: "alt",
      type: "text",
      friendlyName: "Alternate text",
      required: true,
      helperText: "Describes the badge for accessibility and SEO.",
      localized: true,
    },
    {
      name: "title",
      type: "text",
      helperText: "Optional tooltip / link title attribute.",
      localized: true,
    },
    {
      name: "width",
      type: "number",
      required: true,
      helperText: "Intrinsic width in px — required to prevent layout shift.",
      localized: false,
    },
    {
      name: "height",
      type: "number",
      required: true,
      helperText: "Intrinsic height in px — required to prevent layout shift.",
      localized: false,
    },
  ],
};
